import React from 'react';
import CollaboratorCard from "./CollaboratorCard";

const Collaborators = ({colData}) => {
    return (
        <div id='alianzas' className="grid md:grid-cols-2 md:gap-x-16 md:px-32 px-6 py-24">
            {colData.map((colItem,index) => {
                return (<CollaboratorCard colItem={colItem} key={index}/>)
            })}
        </div>
    );
};

export default Collaborators;
